<div id="dept-cs" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h2 class="title">Department of Computer Science</h2>
    <p class="inner-lead mt-3">
      The Department of Computer Science at Shah Satnam Ji Girls' College, Sirsa is equipped with modern computer laboratories and experienced faculty. The department prepares students for careers in IT, software development and emerging technology fields.
    </p>

    <hr class="divider">

    <h4 class="section-subtitle">Courses Offered</h4>
    <ul class="inner-lead">
      <li>Bachelor of Computer Applications (BCA)</li>
      <li>B.Sc. (Computer Science)</li>
      <li>B.Com (Vocational) — IT elective</li>
    </ul>

    <hr class="divider">

    <h4 class="section-subtitle">Faculty</h4>
    <div class="table-responsive-inner mt-3">
      <table class="inner-table">
        <thead>
          <tr>
            <th>Sr. No.</th>
            <th>Name</th>
            <th>Qualification</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>1</td><td>Dr. Chanchal Rani</td><td>Ph.D, CSIR-UGC NET</td></tr>
          <tr><td>2</td><td>Ms. Nisha Phutela</td><td>MCA, M.Tech</td></tr>
          <tr><td>3</td><td>Ms. Minakhshi</td><td>MCA</td></tr>
          <tr><td>4</td><td>Dr. Divya</td><td>Ph.D, UGC NET</td></tr>
          <tr><td>5</td><td>Ms. Priynka</td><td>MCA, M.Tech</td></tr>
          <tr><td>6</td><td>Ms. Komal</td><td>MCA</td></tr>
          <tr><td>7</td><td>Ms. Veena Navjot</td><td>MCA</td></tr>
          <tr><td>8</td><td>Ms. Rupa</td><td>B.Tech, M.Tech</td></tr>
          <tr><td>9</td><td>Ms. Neha Arora</td><td>B.Tech, M.Tech</td></tr>
        </tbody>
      </table>
    </div>

    <hr class="divider">

    <h4 class="section-subtitle">Department Activities</h4>
    <h5 class="section-subtitle-orange" style="font-size:1rem;">2023–24</h5>
    <ul class="inner-lead">
      <li>Professional Career Counselling Seminar</li>
    </ul>

    <h5 class="section-subtitle-orange" style="font-size:1rem;">2022–23</h5>
    <ul class="inner-lead">
      <li>World Computer Literacy Day — PPT Competition</li>
      <li>Techno-fest on National Technology Day</li>
    </ul>

  </div>
</div>
